import convertUnitFromMap from 'helpers/convertUnitFromMap'
import convertUnitToMap from 'helpers/convertUnitToMap'

export default (overlay, isImperial, dropLength) => {
  if (!overlay) return ''

  const distance = overlay.getPath().getArray().reduce((sum, point, index, path) => index !== 0 ? sum + google.maps.geometry.spherical.computeDistanceBetween(point, path[index - 1]) : sum, 0)

  let convertedDistance
  if (isImperial) {
    convertedDistance = convertUnitFromMap({ value: distance, isImperial }) + dropLength
  } else {
    convertedDistance = distance + convertUnitToMap({ value: dropLength, isImperial: true })
  }

  return {
    distance: convertedDistance.toFixed() + (isImperial ? ' ft' : ' m'),
    showWarning: convertedDistance > (isImperial ? 328 : 100),
    rawDistance: convertedDistance
  }
}



// WEBPACK FOOTER //
// ./src/helpers/wires/getWireDistance.js